module.exports = __webpack_public_path__ + "static/media/publicsonar_publicsafety_selected.3b69b6d2.svg";